export default __webpack_public_path__ + "static/media/connect_team2.1f9f1a7e.png";